import React, { useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../actions';

const LoginForm = props => {
    const { register, handleSubmit, reset } = useForm({ mode: "onSubmit" });

    // const isLoading = useSelector(state => state.auth.isLoading);
    const captchaImage = useSelector(state => state.auth.captchaImage);
    const error = useSelector(state => state.auth.error);
    const dispatch = useDispatch();

    const fetchCaptcha = useCallback(() => dispatch(actions.fetchCaptcha()), [dispatch]);
    const login = useCallback(async formData => dispatch(actions.login(formData)), [dispatch]);

    const resetHandler = useCallback(() => {
        const defaultLoginData = { account: '', password: '', answer: '' };
        reset(defaultLoginData);
    }, [reset]);

    const loginHandler = async (data) => {
        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }

        await login(data);
        fetchCaptcha();
    }

    useEffect(() => {
        resetHandler();
        fetchCaptcha();

        const interval = setInterval(() => {
            fetchCaptcha();
        }, 60 * 1000);

        return () => clearInterval(interval);
    }, [resetHandler, fetchCaptcha]);

    return (
        <form onSubmit={handleSubmit(loginHandler)}>
            <div className='body_box'>
                <div className='login_logo'>
                    <img src='../images/login_logo.png' alt='海洋委員會海洋保育署-海洋野生動物簽審通關作業平台LOGO' />
                </div>

                <div className='login_box'>
                    <div className='logintit'>
                        <img src='../images/login_box_bg.png' alt='系統登入' />
                    </div>
                    <div className='typbox'>
                        <ul>
                            <li>
                                <span>帳號：</span>
                                <input
                                    type='text'
                                    maxLength='32'
                                    placeholder='請輸入帳號'
                                    autoComplete='off'
                                    name='account'
                                    ref={register}
                                />
                            </li>
                            <li>
                                <span>密碼：</span>
                                <input
                                    type='password'
                                    maxLength='64'
                                    placeholder='請輸入密碼'
                                    name='password'
                                    ref={register}
                                />
                            </li>
                            <li className='login_code'><span>驗證碼：</span>
                                <input
                                    type='text'
                                    maxLength='6'
                                    className='login_nb'
                                    autoComplete='off'
                                    name='answer'
                                    ref={register}
                                />
                                {captchaImage && <img src={captchaImage} alt='驗證碼' />}
                                <button
                                    type='button'
                                    className='rnBt_icon'
                                    style={{ border: 'none', outline: 'none' }}
                                    onClick={fetchCaptcha}
                                >
                                    <img src='../images/rn.png' alt='重置驗證碼' />
                                </button>
                            </li>
                        </ul>

                        <div style={{ textAlign: 'center', color: '#FFEB3B' }}>
                            <p>{error && error}</p>
                        </div>

                        <div className='login_btn'>
                            <button type='submit' className='loginBt' > 登 入 </button>
                            <button type='button' className='clearBt' onClick={resetHandler}> 重 填 </button>
                        </div>

                        <div className="logBox_menu">
                            <ul>
                                <li><a href="/RegisterAccount" data-toggle="modal">業者帳號申請</a><span>|</span></li>
                                <li><a href="/RegisterOrgAccount" data-toggle="modal">機關端帳號申請</a><span>|</span></li>
                                <li><a href="/#" data-toggle="modal" data-target={'#' + props.requestForms.forgetAccount.id}>忘記帳號</a><span>|</span></li>
                                <li><a href="/#" data-toggle="modal" data-target={'#' + props.requestForms.forgetPassword.id}>忘記密碼</a><span>|</span></li>
                                <li><a href="/#" data-toggle="modal" data-target={'#' + props.requestForms.unlockAccount.id}>帳號解鎖</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
}

export default LoginForm;